var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editData)?_c('div',[_c('DocumentBuilder',{attrs:{"editMode":true,"editModeName":_vm.editModeName,"editData":_vm.editData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }